import * as Yup from 'yup'
import { noop } from 'lodash'

const CommonSchema = {
  headerTitle: Yup.string(),
  config: Yup.object().shape({
    xKey: Yup.string().required(),
    title: Yup.string(),
    series: Yup.array().required()
  }),
  size: Yup.string(),
  data: Yup.array().nullable(true),
  color: Yup.object().shape({ labelColor: Yup.string().required() }),
  theme: Yup.string().required(),
  language: Yup.string().required()
}
export const LineSchema = Yup.object().shape({
  ...CommonSchema
})

export const ColumnSchema = Yup.object().shape({
  ...CommonSchema
})

export const GroupedSchema = Yup.object().shape({
  ...CommonSchema
})

export const HorizontalStackedSchema = Yup.object().shape({
  ...CommonSchema,
  config: Yup.object().shape({
    title: Yup.string(),
    series: Yup.array().required(),
    yKey: Yup.string().required()
  })
})

export const HorizontalGroupedSchema = Yup.object().shape({
  ...CommonSchema,
  config: Yup.object().shape({
    title: Yup.string(),
    series: Yup.array().required(),
    yKey: Yup.string().required()
  })
})

export const StackedSchema = Yup.object().shape({
  ...CommonSchema
})

export const HybridSchema = Yup.object().shape({
  ...CommonSchema,
  config: Yup.object().shape({
    xKey: Yup.string().required(),
    title: Yup.string(),
    series: Yup.array().of(
      Yup.object().shape({
        config: Yup.array().required(),
        type: Yup.string().required()
      })
    ),
    sync: Yup.boolean(),
    secondAxesTitle: Yup.string()
  })
})

export const PieSchema = Yup.object().shape({
  ...CommonSchema,
  config: Yup.object().shape({
    xKey: Yup.string().required(),
    title: Yup.string(),
    series: Yup.array().required(),
    pieRadius: Yup.string(),
    innerRadius: Yup.string()
  })
})

export const validateSchema = (Schema = { validateSync: noop }, body) => {
  try {
    Schema.validateSync(body)
    return null
  } catch (error) {
    return error
  }
}
